// extracted by mini-css-extract-plugin
module.exports = {"headline":"ieh5X"};